import page from 'page';
import Router from './Router.svelte';
import Route from './Route.svelte';
import NotFoundRoute from './NotFoundRoute.svelte';
function redirect(path) {
    page.redirect(path);
}
export { Router, Route, NotFoundRoute, redirect };
